import type { Variant } from '~/types/featureFlagsProvider';

export const useFeatureFlags = () => {
  const { $featureFlagsProvider } = useNuxtApp();

  const { user, authId } = useAuth();

  const configStore = useConfigStore();

  const userContext = computed(() => {
    return {
      userId: authId.value,
      // The account's state, the one the backend Unleash context reads.
      stateCode: user.value?.accountState?.code || 'UNKNOWN',
      clusterCode: configStore.cluster?.code || 'UNKNOWN',
      // Mirrors the backend Unleash context (UnleashUserContextService), so a
      // countryCode-constrained strategy answers the same on both runtimes.
      countryCode: configStore.cluster?.country?.code || 'UNKNOWN',
    };
  });

  const getFlag = async (flagName: string) => await $featureFlagsProvider.getFlag(flagName, userContext.value);

  const getVariant = async (flagName: string): Promise<Variant> => await $featureFlagsProvider.getVariant(flagName, userContext.value);

  const getEvaluatedFlags = () => $featureFlagsProvider.getEvaluatedFlags();

  return {
    getFlag,
    getVariant,
    getEvaluatedFlags,
  };
};
